import Storage from 'common/lib/storage';
import { createReducer } from 'util/reducers';

export interface LabelUiState {
  showText: boolean;
}

const initialState: LabelUiState = Storage.get('labelState') || {
  showText: false,
};

export default createReducer(initialState, {
  // TODO: Sync this state with classic in real-time
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/labels.ts